import { ReactNode, useEffect } from "react";

import { WelcomePage } from "@/pages/WelcomePage";
import { useGetUserQuery } from "@/store/services/user.service";
import { isFetchBaseQueryError } from "@/utils/rtk-query.utils";

type Props = {
    children: ReactNode;
    addUserNotFound?: () => void;
    resetUserNotFound: () => void;
};

const GetUser = ({ children, addUserNotFound: onUserNotFound, resetUserNotFound }: Props) => {
    const { isLoading, error } = useGetUserQuery();

    const isUserNotFoundError = isFetchBaseQueryError(error) && error.status === 401;

    useEffect(() => {
        resetUserNotFound();
    }, [resetUserNotFound]);

    useEffect(() => {
        if (isUserNotFoundError) {
            onUserNotFound?.();
        }
    }, [isUserNotFoundError, onUserNotFound]);

    if (isLoading || isUserNotFoundError) {
        return <WelcomePage />;
    }

    return children;
};

export { GetUser };
